import { AttentionBanner, Banner } from '@procore/core-react';
import * as React from 'react';
export default {
  AttentionBanner,
  Banner,
  React
};